import {
  USER_LIST_PAGE_LOADED,
  USER_LIST_NEXT_PAGE_LOADED,
  USER_LIST_SEARCH_LOADED,
  UPDATE_FIELD_SEARCHTERM,
  USER_LIST_PAGE_UNLOADED,
  ETH_COMMIT_USER_LIST_PAGE_LOADED,
  ETH_COMMIT_USER_LIST_PAGE_UNLOADED,
  BTC_COMMIT_USER_LIST_PAGE_LOADED,
  BTC_COMMIT_USER_LIST_PAGE_UNLOADED,
  USER_LIST_EXPORT,
  MERCHANT_LIST_PAGE_LOADED,
  MERCHANT_LIST_PAGE_UNLOADED,
  CLEAR_PROPS,
  LOAD_USERS_REPORTS
} from '../constants/actionTypes';
import { PAGESIZE } from '../constants/config'
export default (state = {}, action) => {
  switch (action.type) {
    case USER_LIST_PAGE_LOADED:
      return {
        ...state,
        users: action.payload[0].users,
        totalCount: action.payload[0].totalCount,
        currentPage: action.currentPage,
        searchTerm: action.searchTerm,
        status: action.status,
        date_from: action.date_from,
        date_to: action.date_to,
        totalPage: Math.ceil(action.payload[0].totalCount / PAGESIZE),
        csvData: null,
        reports: action.payload[1] || [],
        primeTokens: action.payload[2] || []
      };

    case USER_LIST_NEXT_PAGE_LOADED:
    case USER_LIST_SEARCH_LOADED:
      return {
        ...state,
        users: action.payload.users,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        searchTerm: action.searchTerm,
        status: action.status,
        date_from: action.date_from,
        date_to: action.date_to,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
        csvData: null
      };
    case UPDATE_FIELD_SEARCHTERM:
      return {
        ...state,
        [action.key]: action.value,
      }
    case ETH_COMMIT_USER_LIST_PAGE_LOADED:
    case BTC_COMMIT_USER_LIST_PAGE_LOADED:
      return {
        ...state,
        users: action.payload.users,
      };
    case MERCHANT_LIST_PAGE_LOADED:
      return {
        ...state,
        merchants: action.payload.users,
      }
    case USER_LIST_PAGE_UNLOADED:
    case ETH_COMMIT_USER_LIST_PAGE_UNLOADED:
    case BTC_COMMIT_USER_LIST_PAGE_UNLOADED:
    case MERCHANT_LIST_PAGE_UNLOADED:
      return {};
    case USER_LIST_EXPORT:
      return {
        ...state,
        csvData: action.payload
      }
    case CLEAR_PROPS:
      return {
        ...state,
        csvData: null
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/userList.js